import {
    GET_ALL_MEDICINE_NAME_BEGIN,
    GET_ALL_MEDICINE_NAME_SUCCESS,
    GET_ALL_MEDICINE_NAME_ERROR,
    ADD_MEDICINE_NAME_BEGIN,
    ADD_MEDICINE_NAME_SUCCESS,
    ADD_MEDICINE_NAME_ERROR,
    GET_MEDICINE_NAME_BEGIN,
    GET_MEDICINE_NAME_ERROR,
    GET_MEDICINE_NAME_SUCCESS,
    UPDATE_MEDICINE_NAME_BEGIN,
    UPDATE_MEDICINE_NAME_SUCCESS,
    UPDATE_MEDICINE_NAME_ERROR,
    DELETE_MEDICINE_NAME_BEGIN,
    DELETE_MEDICINE_NAME_SUCCESS,
    DELETE_MEDICINE_NAME_ERROR,
  } from "./constants";
  
  const initState = {
    list: [],
    loading: false,
    error: null,
  };
  
  const MedicineNameReducer = (state = initState, action) => {
    const { type, data, error } = action;
    switch (type) {
      case GET_ALL_MEDICINE_NAME_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case GET_ALL_MEDICINE_NAME_SUCCESS:
        return {
          ...state,
          list: data,
          loading: false,
        };
      case GET_ALL_MEDICINE_NAME_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case ADD_MEDICINE_NAME_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case ADD_MEDICINE_NAME_SUCCESS:
        return {
          ...state,
          loading: false,
          list: [...state.list, data],
        };
      case ADD_MEDICINE_NAME_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case GET_MEDICINE_NAME_BEGIN:
        return {
          ...state,
          loading: true,
          medicineNameData: "",
        };
      case GET_MEDICINE_NAME_SUCCESS:
        return {
          ...state,
          loading: false,
          medicineNameData: data,
        };
      case GET_MEDICINE_NAME_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case UPDATE_MEDICINE_NAME_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case UPDATE_MEDICINE_NAME_SUCCESS:
        return {
          ...state,
          loading: false,
          list: state.list.map((ele) => {
            if (ele.id === data.id) {
              return { ...data };
            } else return ele;
          }),
        };
      case UPDATE_MEDICINE_NAME_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case DELETE_MEDICINE_NAME_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case DELETE_MEDICINE_NAME_SUCCESS:
        return {
          ...state,
          loading: false,
          list: state.list.filter((ele) => ele.id !== data.id),
        };
      case DELETE_MEDICINE_NAME_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      default:
        return state;
    }
  };
  
  export default MedicineNameReducer;
  